import { render, staticRenderFns } from "./InctInfoElement.vue?vue&type=template&id=5fb6d3ba&scoped=true"
import script from "./InctInfoElement.vue?vue&type=script&lang=js"
export * from "./InctInfoElement.vue?vue&type=script&lang=js"
import style0 from "./InctInfoElement.vue?vue&type=style&index=0&id=5fb6d3ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6d3ba",
  null
  
)

export default component.exports